import '@pds/prescriber-design-system/dist/pds-tailwind.css';
import './styles/normalize.scss';
import 'lato-font';
import 'icons/styles.css';
import './styles/main.scss';
import './styles/animate.css';
import 'vue-search-select/dist/VueSearchSelect.css';
import 'vue-select/dist/vue-select.css';

import FloatingVue from 'floating-vue';
import 'floating-vue/dist/style.css';
import './styles/tooltip.css';

import VueImageZoomer from 'vue-image-zoomer';
import 'vue-image-zoomer/dist/style.css';
import './styles/imageZoomer.css';

import { VueRecaptcha } from 'vue-recaptcha';
import { ModelSelect } from 'vue-search-select';

import Vue3CountryIntl from 'vue3-country-intl';
import 'vue3-country-intl/lib/vue3-country-intl.css';

// shared component styles
import '@/components/shared/form/FormGroup.scss';

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { initAxios, formLogout, dailySessionReset, handleUserIdle } from '@/services';
import { createGtm, useGtm } from '@gtm-support/vue-gtm';

import { createApp } from 'vue';
import App from './App.vue';
import store from '@/store';
import router from './router';
import mitt from 'mitt';
import vClickout from 'vue3-clickout';

// PrescriberDesignSystem - Web Components Section
import PdsNavigation from '@pds/prescriber-design-system';
import Alert from '@/components/webcomponents/Alert';
import Card from '@/components/webcomponents/Card';
import ModalDialog from '@/components/webcomponents/ModalDialog';
import Notification from '@/components/webcomponents/Notification';
import PageHeader from '@/components/webcomponents/PageHeader';
import Toggle from '@/components/webcomponents/Toggle';
import InputGroups from './components/webcomponents/InputGroups.vue';
import ComboBoxes from './components/webcomponents/ComboBoxes.vue';
import Tabs from './components/webcomponents/Tabs.vue';
import Tables from './components/webcomponents/Tables.vue';
import { useRouter } from 'vue-router';

initAxios();
dailySessionReset();
export const app = createApp(App);
const emitter = mitt();
const gtmPlugin = createGtm({
  id: 'GTM-5JZVM3L',
  queryParams: {},
  enabled: true,
  debug: false,
  loadScript: true,
  vueRouter: router,
  ignoredViews: []
});

app.use(store);
app.use(router);
app.use(gtmPlugin);
app.use(FloatingVue);
app.use(VueImageZoomer);
app.use(vClickout);
app.use(PdsNavigation);

let idleTimer = null;

function startIdleTimer() {
  clearTimeout(idleTimer);

  idleTimer = setTimeout(() => {
    const isLoginPage = window.location.pathname.startsWith('/inloggen');
    const isInIframe = window.self !== window.top;

    if (!isLoginPage && !isInIframe) {
      handleUserIdle();
    }
    // }, 60000); // 1 min for testing
  }, 8 * 60 * 60 * 1000); // 1 hr
}

if (window.self === window.top) {
  // start immediately
  startIdleTimer();

  // attach events to DOCUMENT, not window
  ['click', 'mousemove', 'keydown', 'touchstart', 'scroll'].forEach((evt) => {
    document.addEventListener(evt, startIdleTimer, true);
  });
} else {
  console.log('Iframe detected — ignoring idle check');
}

// shared
import Button from '@/components/shared/Button';
import Heading from '@/components/shared/Heading';
import InputGroup from '@/components/shared/form/InputGroup';
import InputGroupSimple from '@/components/shared/form/simple/InputGroup';
import InputGroupSimple2 from '@/components/shared/form/simple/InputGroup2';
import SelectGroup from '@/components/shared/form/SelectGroup';
import TextareaGroup from '@/components/shared/form/TextareaGroup';
import Paragraph from '@/components/shared/Paragraph';
import Overlay from '@/components/shared/Overlay';

app.config.productionTip = false;
// register vue components global
app.component(Button.name, Button);
app.component(Heading.name, Heading);
app.component(InputGroup.name, InputGroup);
app.component(Paragraph.name, Paragraph);
app.component(Overlay.name, Overlay);
app.component(InputGroupSimple.name, InputGroupSimple);
app.component(InputGroupSimple2.name, InputGroupSimple2);
app.component(SelectGroup.name, SelectGroup);
app.component(TextareaGroup.name, TextareaGroup);
app.component('VueRecaptcha', VueRecaptcha);
app.component('ModelSelect', ModelSelect);
app.component(Vue3CountryIntl.name, Vue3CountryIntl);

// Web components section
app.component(Alert.name, Alert);
app.component(Card.name, Card);
app.component('ModalDialog', ModalDialog);
app.component('Notification', Notification);
app.component(PageHeader.name, PageHeader);
app.component('Toggle', Toggle);
app.component(InputGroups.name, InputGroups);
app.component(ComboBoxes.name, ComboBoxes);
app.component('Tabs', Tabs);
app.component('Tables', Tables);

// Filters
import { formatDate } from './filters/dateUtils.js';
import { toTitleCase } from './utils/convertToTitleCaseUtils.js';

// Mixin
import LoadAlternateImage from '@/mixins/LoadAlternateImage.js';
app.mixin(LoadAlternateImage);

// Google recaptcha site key
app.config.globalProperties.$googleRecaptchaSiteKey = '6LecOWEUAAAAAL9AUSqbWz_ngQb-pBvIVWFiYQGn';
app.config.globalProperties.$featureFlag = [];
app.config.globalProperties.$featureFlagIdentities = {};
app.config.globalProperties.$emitter = emitter;
app.config.globalProperties.$formatDate = formatDate;
app.config.globalProperties.$toTitleCase = toTitleCase;
app.config.globalProperties.$isInIframe = window.self !== window.top;
app.config.globalProperties.$gtm = {
  push: (...args) => {
    const gtmInstance = useGtm();
    return gtmInstance.push(...args);
  }
};
app.provide('$gtm', app.config.globalProperties.$gtm);

app.mount('#app');
